import { render, staticRenderFns } from "./SafetyMode.vue?vue&type=template&id=54df0b4c&scoped=true&"
import script from "./SafetyMode.vue?vue&type=script&lang=js&"
export * from "./SafetyMode.vue?vue&type=script&lang=js&"
import style0 from "./SafetyMode.vue?vue&type=style&index=0&id=54df0b4c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-add9cc88d1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54df0b4c",
  null
  
)

export default component.exports